import {
    Backdrop,
    Box,
    Button,
    Checkbox,
    Chip,
    CircularProgress,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    List,
    ListItem,
    ListItemText,
    MenuItem,
    Paper,
    Select,
    Switch,
    TextField as MuiTextField,
    Tooltip,
    Typography,
    useMediaQuery,
    useTheme,
} from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import {
    AccountTree,
    Business,
    BusinessCenter,
    CloudUpload,
    Contacts,
    Image,
    LocationOn,
    Lock,
    Refresh,
    Save,
    Storefront,
    TrendingUp,
    Tune,
    Visibility,
    VisibilityOff,
} from "@material-ui/icons"
import { Autocomplete } from "@material-ui/lab"
import { useSnackbar } from "notistack"
import { forwardRef, useEffect, useRef, useState } from "react"
import { Controller, useForm } from "react-hook-form"
import { Prompt } from "react-router-dom"
import { ComumCep } from "../../services/comum"
import {
    buscarCidades,
    buscarEstabelecimentosPaginado,
    buscarRedeDeEstabelecimentos,
    getCadastroEstabelecimento,
    salvarCadastroEstabelecimento,
    uploadLogoEstabelecimento,
} from "../../services/integracao"
import useAppStore from "../../stores/AppStore"
import useDebounce from "../../utils/useDebounce"
import Cabecalho from "../Cabecalho"
import {
    CATEGORIAS,
    MascaraCEP,
    MascaraCNPJ,
    MascaraTelefone,
    MAX_LOGO_BYTES,
    MIME_LOGO_ACEITOS,
    PLANOS,
} from "./masks"

const UFS_BRASIL = [
    "AC",
    "AL",
    "AP",
    "AM",
    "BA",
    "CE",
    "DF",
    "ES",
    "GO",
    "MA",
    "MT",
    "MS",
    "MG",
    "PA",
    "PB",
    "PR",
    "PE",
    "PI",
    "RJ",
    "RN",
    "RS",
    "RO",
    "RR",
    "SC",
    "SP",
    "SE",
    "TO",
]

const MODOS_IZZA = [
    { value: 0, label: "0 - Desligado" },
    { value: 1, label: "1 - Boas Vindas" },
    { value: 3, label: "3 - Boas Vindas + Notificações" },
    { value: 4, label: "4 - Notificações" },
    { value: 2, label: "2 - Completo (Desativado, Use a GPT)" },
    { value: 5, label: "5 - Menu" },
    { value: 6, label: "6 - GPT" },
    { value: 7, label: "7 - GPT (Sem boas vindas padrão)" },
]

const useStyles = makeStyles(theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 999999,
        color: "#fff",
    },
    container: {
        paddingLeft: "90px",
        paddingRight: "10px",
        paddingTop: "100px",
        paddingBottom: "120px",
        [theme.breakpoints.down("md")]: {
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "80px",
        },
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingTop: "70px",
        },
    },
    content: {
        margin: "auto",
        maxWidth: "1100px",
        [theme.breakpoints.down("sm")]: {
            maxWidth: "100%",
        },
    },
    header: {
        marginBottom: theme.spacing(4),
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            alignItems: "flex-start",
            gap: theme.spacing(1),
            marginBottom: theme.spacing(3),
        },
    },
    headerTitle: {
        display: "flex",
        flexDirection: "column",
    },
    titleText: {
        fontWeight: 600,
        color: "#2c3e50",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.5rem",
        },
        [theme.breakpoints.down("xs")]: {
            fontSize: "1.25rem",
        },
    },
    configCard: {
        borderRadius: 20,
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        backgroundColor: "white",
        overflow: "hidden",
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down("sm")]: {
            borderRadius: 15,
            marginBottom: theme.spacing(2),
        },
    },
    cardHeader: {
        backgroundColor: "#f8f9fa",
        padding: theme.spacing(2.5),
        borderBottom: "2px solid #e9ecef",
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2),
            flexWrap: "wrap",
        },
    },
    cardHeaderTitle: {
        fontWeight: 600,
        color: "#2c3e50",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.1rem",
        },
    },
    cardContent: {
        padding: theme.spacing(3),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2),
        },
    },
    iconHeader: {
        color: "#4caf50",
        marginRight: theme.spacing(1),
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.2rem",
        },
    },
    logoBox: {
        width: 200,
        height: 160,
        borderRadius: 12,
        border: "1px solid #e0e0e0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        backgroundColor: "#f8f9fa",
    },
    logoImg: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
    },
    uploadButton: {
        borderRadius: 25,
        background: "linear-gradient(135deg,#5DADE2 0%,#76D7C4 100%)",
        color: "white",
        fontWeight: 600,
        boxShadow: "0 2px 8px rgba(93,173,226,0.3)",
        textTransform: "none",
        padding: theme.spacing(1, 2.5),
        "&:hover": {
            background: "linear-gradient(135deg,#4a9bd1 0%,#5fc7d1 100%)",
        },
    },
    sticky: {
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "#fff",
        boxShadow: "0 -2px 8px rgba(0,0,0,0.08)",
        padding: theme.spacing(1.5, 3),
        display: "flex",
        justifyContent: "flex-end",
        zIndex: theme.zIndex.appBar - 1,
        gap: theme.spacing(1),
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            gap: theme.spacing(1),
            padding: theme.spacing(1.5),
        },
    },
    saveButton: {
        borderRadius: 25,
        backgroundColor: "#4caf50",
        color: "white",
        padding: theme.spacing(1, 3),
        fontWeight: 600,
        boxShadow: "0 4px 15px rgba(76, 175, 80, 0.3)",
        textTransform: "none",
        minWidth: 160,
        "&:hover": {
            backgroundColor: "#45a049",
            boxShadow: "0 6px 20px rgba(76, 175, 80, 0.4)",
        },
        "&.Mui-disabled": {
            backgroundColor: "#c8e6c9",
            color: "#fff",
        },
    },
    discardButton: {
        borderRadius: 25,
        backgroundColor: "white",
        color: "#374151",
        border: "1px solid #d1d5db",
        textTransform: "none",
        fontWeight: 500,
        padding: theme.spacing(1, 3),
        minWidth: 140,
        "&:hover": { backgroundColor: "#f9fafb" },
    },
    statusText: {
        alignSelf: "center",
        marginRight: "auto",
        color: "#7f8c8d",
        [theme.breakpoints.down("sm")]: {
            marginRight: 0,
            marginBottom: theme.spacing(0.5),
        },
    },
    deniedCard: {
        borderRadius: 20,
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        backgroundColor: "white",
        padding: theme.spacing(6, 4),
        textAlign: "center",
        marginTop: theme.spacing(4),
    },
    deniedIcon: {
        fontSize: 64,
        color: "#f44336",
        marginBottom: theme.spacing(2),
    },
    inputFile: { display: "none" },
}))

// Wrapper que (1) força o label a permanecer encolhido — resolve o overlap do
// MUI v4 quando react-hook-form faz `reset()` — e (2) encaminha o ref do
// `register()` para o `inputRef` da MuiTextField.
const TextField = forwardRef((props, ref) => (
    <MuiTextField
        {...props}
        inputRef={ref}
        InputLabelProps={{ shrink: true, ...(props.InputLabelProps || {}) }}
    />
))

const SecaoCard = ({ classes, titulo, sufixo, icon: Icon, children }) => (
    <Paper className={classes.configCard} elevation={0}>
        <Box className={classes.cardHeader}>
            {Icon && <Icon className={classes.iconHeader} />}
            <Typography variant="h6" className={classes.cardHeaderTitle}>
                {titulo}
            </Typography>
            {sufixo && (
                <Typography
                    variant="caption"
                    style={{
                        marginLeft: 8,
                        color: "#7f8c8d",
                        fontStyle: "italic",
                        fontWeight: 500,
                    }}
                >
                    {sufixo}
                </Typography>
            )}
        </Box>
        <Box className={classes.cardContent}>{children}</Box>
    </Paper>
)

const valoresPadrao = () => ({
    id: null,
    nome: "",
    nomeAlternativo: "",
    cnpj: "",
    codigo: "",
    codigoIugu: "",
    descricao: "",
    categoria: "",
    ativo: true,
    visivel: true,
    email: "",
    telefone: "",
    numeroWhatsapp: "",
    whatsappgrupo: "",
    emailResponsavel: "",
    telefoneResponsavel: "",
    endereco: "",
    numero: "",
    bairro: "",
    cep: "",
    latitude: "",
    longitude: "",
    idCidade: null,
    nomeCidade: "",
    ufCidade: "",
    urlLogo: "",
    urlLogoRepresentante: "",
    urlSite: "",
    urlFacebook: "",
    urlInstagram: "",
    imagemDescricaoPromocao: "",
    idRede: null,
    nomeRede: "",
    planoAssinatura: "",
    modoIzza: 0,
    permiteDesconto: false,
    permiteRegistros: false,
    unificarCartelas: false,
    delivery: false,
    enviarWhatsappFilial: false,
    valorMinimoParaCompra: "",
    descricaoBrinde: "",
    observacaoBrinde: "",
    quantidadeParaBrinde: "",
    diasValidadeCartela: "",
    bonificarIndicacaoAmigos: false,
    bonificarPesquisaSatisfacao: false,
    maximoRegistroSelosImpressosDiarios: "",
    maximoRegistroSelosVirtuaisDiarios: "",
    senhaResgate: "",
    tagManager: "",
    pixel: "",
    apiconversao: "",
    formasPagamento: [],
    perfilClienteFiel: false,
    representante: false,
})

const normalizarVazios = obj => {
    const result = {}
    Object.entries(obj).forEach(([k, v]) => {
        if (v === "") result[k] = null
        else result[k] = v
    })
    return result
}

export default function CadastroEstabelecimento() {
    const classes = useStyles()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
    const { enqueueSnackbar } = useSnackbar()
    const autorizacao = localStorage.getItem("chaveSistema")

    const idEstabelecimento = useAppStore(
        s => s.configuracoes?.user?.parametros?.estabelecimento?.id
    )
    const appNome = useAppStore(s => s.configuracoes?.user?.parametros?.appNome)
    const perfilUsuario = useAppStore(s => s.configuracoes?.user?.perfil)
    const ehClienteFiel = perfilUsuario === "CLIENTEFIEL"
    const ehAdministrador = perfilUsuario === "ADMINISTRADOR"
    const podeAcessar = ehClienteFiel || ehAdministrador

    const [carregando, setCarregando] = useState(podeAcessar)
    const [salvando, setSalvando] = useState(false)
    const [erroCarregar, setErroCarregar] = useState("")
    const [mostrarSenhaResgate, setMostrarSenhaResgate] = useState(false)
    const [opcoesCidades, setOpcoesCidades] = useState([])
    const [inputCidade, setInputCidade] = useState("")
    const [loadingCidades, setLoadingCidades] = useState(false)
    const [filiais, setFiliais] = useState([])
    const [carregandoFiliais, setCarregandoFiliais] = useState(false)
    const [opcoesRede, setOpcoesRede] = useState([])
    const [inputRede, setInputRede] = useState("")
    const [loadingRede, setLoadingRede] = useState(false)
    const [geocodificando, setGeocodificando] = useState(false)
    const inputLogoRef = useRef(null)
    const inputLogoRepRef = useRef(null)
    const inputCidadeDebounced = useDebounce(inputCidade, 300)
    const inputRedeDebounced = useDebounce(inputRede, 300)

    const {
        register,
        handleSubmit,
        reset,
        watch,
        control,
        setValue,
        formState: { isDirty, errors },
    } = useForm({ defaultValues: valoresPadrao(), mode: "onBlur" })

    const perfilClienteFiel = watch("perfilClienteFiel")
    const representante = watch("representante")
    const urlLogo = watch("urlLogo")
    const urlLogoRepresentante = watch("urlLogoRepresentante")
    const ufCidadeSelecionada = watch("ufCidade")
    const enderecoWatch = watch("endereco")
    const numeroWatch = watch("numero")
    const bairroWatch = watch("bairro")
    const nomeCidadeWatch = watch("nomeCidade")
    const enderecoCompleto = [
        enderecoWatch,
        numeroWatch,
        bairroWatch,
        nomeCidadeWatch,
        ufCidadeSelecionada,
    ]
        .map(v => (v || "").toString().trim())
        .join(", ")
    const enderecoDebounced = useDebounce(enderecoCompleto, 700)

    const carregar = async () => {
        if (!idEstabelecimento) return
        setCarregando(true)
        setErroCarregar("")
        const resp = await getCadastroEstabelecimento(idEstabelecimento, autorizacao)
        setCarregando(false)
        if (resp.retornoErro) {
            setErroCarregar(resp.mensagem)
            return
        }
        reset({ ...valoresPadrao(), ...resp.data })
    }

    useEffect(() => {
        if (!podeAcessar) return
        carregar()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idEstabelecimento, podeAcessar])

    useEffect(() => {
        const handler = e => {
            if (isDirty) {
                e.preventDefault()
                e.returnValue = ""
            }
        }
        window.addEventListener("beforeunload", handler)
        return () => window.removeEventListener("beforeunload", handler)
    }, [isDirty])

    useEffect(() => {
        let cancelado = false
        const carregarCidades = async () => {
            if (!inputCidadeDebounced || inputCidadeDebounced.length < 2) return
            setLoadingCidades(true)
            const resp = await buscarCidades(
                {
                    q: inputCidadeDebounced,
                    uf: ufCidadeSelecionada || undefined,
                    limit: 50,
                },
                autorizacao
            )
            if (cancelado) return
            setLoadingCidades(false)
            if (!resp.retornoErro) setOpcoesCidades(resp.cidades)
        }
        carregarCidades()
        return () => {
            cancelado = true
        }
    }, [inputCidadeDebounced, ufCidadeSelecionada, autorizacao])

    useEffect(() => {
        if (!ehClienteFiel) return
        let cancelado = false
        const carregarRede = async () => {
            setLoadingRede(true)
            const resp = await buscarEstabelecimentosPaginado(
                {
                    q: inputRedeDebounced || "",
                    apenasAtivos: true,
                    page: 1,
                    size: 20,
                },
                autorizacao
            )
            if (cancelado) return
            setLoadingRede(false)
            if (!resp.retornoErro) setOpcoesRede(resp.estabelecimentos || [])
        }
        carregarRede()
        return () => {
            cancelado = true
        }
    }, [inputRedeDebounced, autorizacao, ehClienteFiel])

    useEffect(() => {
        if (!isDirty) return
        if (!enderecoWatch || !numeroWatch || !nomeCidadeWatch || !ufCidadeSelecionada) return
        if (!window.google?.maps?.Geocoder) return
        let cancelado = false
        const geocodificar = async () => {
            try {
                setGeocodificando(true)
                const geocoder = new window.google.maps.Geocoder()
                const resp = await geocoder.geocode({ address: enderecoDebounced })
                if (cancelado) return
                const primeiro = resp?.results?.[0]
                if (!primeiro) return
                const lat = primeiro.geometry?.location?.lat?.()
                const lng = primeiro.geometry?.location?.lng?.()
                if (typeof lat === "number" && typeof lng === "number") {
                    setValue("latitude", String(lat), { shouldDirty: true })
                    setValue("longitude", String(lng), { shouldDirty: true })
                }
            } catch (error) {
                // silencioso — geocodificação é melhor-esforço
            } finally {
                if (!cancelado) setGeocodificando(false)
            }
        }
        geocodificar()
        return () => {
            cancelado = true
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enderecoDebounced])

    useEffect(() => {
        if (!ehClienteFiel) return
        let cancelado = false
        const carregarFiliais = async () => {
            if (!idEstabelecimento) return
            setCarregandoFiliais(true)
            const resp = await buscarRedeDeEstabelecimentos(autorizacao)
            if (cancelado) return
            setCarregandoFiliais(false)
            if (resp?.retornoErro || !Array.isArray(resp)) {
                setFiliais([])
                return
            }
            const filhas = resp.filter(
                e => e.idRede === idEstabelecimento && e.id !== idEstabelecimento
            )
            setFiliais(filhas)
        }
        carregarFiliais()
        return () => {
            cancelado = true
        }
    }, [idEstabelecimento, autorizacao, ehClienteFiel])

    const buscarCep = async cep => {
        const limpo = (cep || "").replace(/\D/g, "")
        if (limpo.length !== 8) return
        const resp = await ComumCep(limpo, appNome)
        if (resp?.retornoErro) {
            enqueueSnackbar(resp.mensagem || "CEP não encontrado.", { variant: "warning" })
            return
        }
        if (resp?.logradouro) setValue("endereco", resp.logradouro, { shouldDirty: true })
        if (resp?.bairro) setValue("bairro", resp.bairro, { shouldDirty: true })
        if (resp?.uf) setValue("ufCidade", resp.uf, { shouldDirty: true })
        if (resp?.localidade) {
            setValue("nomeCidade", resp.localidade, { shouldDirty: true })
            try {
                const respCidades = await buscarCidades(
                    { q: resp.localidade, uf: resp.uf || undefined, limit: 5 },
                    autorizacao
                )
                const match = (respCidades?.cidades || []).find(
                    c =>
                        c.nome?.toLowerCase() === resp.localidade?.toLowerCase() &&
                        (!resp.uf || c.uf === resp.uf)
                )
                if (match) {
                    setValue("idCidade", match.id, { shouldDirty: true })
                    setValue("nomeCidade", match.nome, { shouldDirty: true })
                    setValue("ufCidade", match.uf, { shouldDirty: true })
                }
            } catch (_) {
                // ignora — campos textuais já foram preenchidos
            }
        }
    }

    const handleUploadLogo = async (file, tipo) => {
        if (!file) return
        if (file.size > MAX_LOGO_BYTES) {
            enqueueSnackbar("Arquivo maior que 2MB.", { variant: "warning" })
            return
        }
        if (!MIME_LOGO_ACEITOS.includes(file.type)) {
            enqueueSnackbar("Formato de imagem não suportado.", { variant: "warning" })
            return
        }
        setSalvando(true)
        const resp = await uploadLogoEstabelecimento(idEstabelecimento, file, tipo, autorizacao)
        setSalvando(false)
        if (resp?.retornoErro) {
            enqueueSnackbar(resp.mensagem, { variant: "error" })
            return
        }
        const campo = tipo === "logo_representante" ? "urlLogoRepresentante" : "urlLogo"
        setValue(campo, resp.url, { shouldDirty: true })
        enqueueSnackbar("Logo enviada. Clique em Salvar para persistir.", { variant: "info" })
    }

    const onSubmit = async dados => {
        if (!idEstabelecimento) return
        setSalvando(true)
        const body = normalizarVazios(dados)
        const resp = await salvarCadastroEstabelecimento(idEstabelecimento, body, autorizacao)
        setSalvando(false)
        if (resp?.retornoErro) {
            enqueueSnackbar(resp.mensagem, { variant: "error" })
            return
        }
        reset({ ...valoresPadrao(), ...resp.data })
        enqueueSnackbar("Dados atualizados com sucesso!", { variant: "success" })
    }

    const onInvalid = errs => {
        const primeiroCampo = Object.keys(errs)[0]
        enqueueSnackbar(
            `Verifique os campos obrigatórios${primeiroCampo ? ` (${primeiroCampo})` : ""}.`,
            { variant: "warning" }
        )
    }

    if (!podeAcessar) {
        return (
            <>
                <Cabecalho pagina="Dados do Estabelecimento" />
                <div className={classes.container}>
                    <div className={classes.content}>
                        <Box className={classes.header}>
                            <Box className={classes.headerTitle}>
                                <Typography variant="h4" className={classes.titleText}>
                                    Dados do Estabelecimento
                                </Typography>
                            </Box>
                        </Box>
                        <Paper className={classes.deniedCard} elevation={0}>
                            <Lock className={classes.deniedIcon} />
                            <Typography
                                variant="h6"
                                style={{ color: "#2c3e50", fontWeight: 600, marginBottom: 8 }}
                            >
                                Acesso restrito
                            </Typography>
                            <Typography variant="body1" style={{ color: "#7f8c8d" }}>
                                Você não tem permissão de acessar esse recurso.
                            </Typography>
                        </Paper>
                    </div>
                </div>
            </>
        )
    }

    if (erroCarregar) {
        return (
            <>
                <Cabecalho pagina="Dados do Estabelecimento" />
                <div className={classes.container}>
                    <div className={classes.content}>
                        <Paper
                            style={{
                                padding: 16,
                                marginTop: 24,
                                backgroundColor: "#fdecea",
                                border: "1px solid #f5c2c0",
                                borderRadius: 12,
                            }}
                        >
                            <Typography variant="body2" style={{ color: "#611a15" }}>
                                {erroCarregar}
                            </Typography>
                            <Box mt={1}>
                                <Button variant="contained" color="primary" onClick={carregar}>
                                    Tentar novamente
                                </Button>
                            </Box>
                        </Paper>
                    </div>
                </div>
            </>
        )
    }

    return (
        <>
            <Cabecalho pagina="Dados do Estabelecimento" />
            <Backdrop className={classes.backdrop} open={carregando || salvando}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Prompt
                when={isDirty && !salvando}
                message="Há alterações não salvas. Deseja realmente sair?"
            />

            <div className={classes.container}>
                <div className={classes.content}>
                    <Box className={classes.header}>
                        <Box className={classes.headerTitle}>
                            <Typography variant="h4" className={classes.titleText}>
                                Dados do Estabelecimento
                            </Typography>
                            <Typography
                                variant="subtitle1"
                                style={{ color: "#7f8c8d", marginTop: 4 }}
                            >
                                Gerencie as informações do seu estabelecimento
                            </Typography>
                        </Box>
                    </Box>

                    <form onSubmit={handleSubmit(onSubmit, onInvalid)}>
                        {/* SEÇÃO 1: IDENTIFICAÇÃO */}
                        <SecaoCard classes={classes} titulo="Identificação" icon={Business}>
                            <Grid container spacing={isMobile ? 2 : 3}>
                                <Grid item xs={12} sm={4} md={3}>
                                    <Box
                                        display="flex"
                                        flexDirection="column"
                                        alignItems="center"
                                        style={{ gap: 8 }}
                                    >
                                        <div className={classes.logoBox}>
                                            {urlLogo ? (
                                                <img
                                                    src={urlLogo}
                                                    alt="Logo"
                                                    className={classes.logoImg}
                                                />
                                            ) : (
                                                <Typography variant="caption" color="textSecondary">
                                                    Sem logo
                                                </Typography>
                                            )}
                                        </div>
                                        <input
                                            ref={inputLogoRef}
                                            type="file"
                                            accept={MIME_LOGO_ACEITOS.join(",")}
                                            className={classes.inputFile}
                                            onChange={e =>
                                                handleUploadLogo(e.target.files?.[0], "logo")
                                            }
                                        />
                                        <Button
                                            startIcon={<CloudUpload />}
                                            className={classes.uploadButton}
                                            onClick={() => inputLogoRef.current?.click()}
                                        >
                                            Enviar Logo
                                        </Button>
                                    </Box>
                                </Grid>
                                <Grid container item xs={12} sm={8} md={9} spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Tooltip
                                            title={
                                                !perfilClienteFiel
                                                    ? "Apenas a equipe Cliente Fiel pode alterar este campo."
                                                    : ""
                                            }
                                        >
                                            <TextField
                                                label="Nome"
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                required
                                                disabled={!perfilClienteFiel}
                                                error={!!errors.nome}
                                                helperText={errors.nome?.message}
                                                {...register("nome", {
                                                    required: "Nome é obrigatório",
                                                })}
                                            />
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Tooltip
                                            title={
                                                !perfilClienteFiel
                                                    ? "Apenas a equipe Cliente Fiel pode alterar este campo."
                                                    : ""
                                            }
                                        >
                                            <TextField
                                                label="Nome alternativo"
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                disabled={!perfilClienteFiel}
                                                {...register("nomeAlternativo")}
                                            />
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Controller
                                            name="cnpj"
                                            control={control}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    value={field.value || ""}
                                                    label="CNPJ"
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    InputProps={{
                                                        inputComponent: MascaraCNPJ,
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={3}>
                                        <TextField
                                            label="Código"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            {...register("codigo")}
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={3}>
                                        <TextField
                                            label="Código Iugu"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            {...register("codigoIugu")}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            label="Descrição"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            multiline
                                            minRows={2}
                                            {...register("descricao")}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Controller
                                            name="categoria"
                                            control={control}
                                            render={({ field }) => (
                                                <FormControl
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                >
                                                    <InputLabel>Categoria</InputLabel>
                                                    <Select
                                                        {...field}
                                                        value={field.value || ""}
                                                        label="Categoria"
                                                    >
                                                        <MenuItem value="">
                                                            <em>Nenhuma</em>
                                                        </MenuItem>
                                                        {CATEGORIAS.map(c => (
                                                            <MenuItem key={c} value={c}>
                                                                {c}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={3}>
                                        <Controller
                                            name="ativo"
                                            control={control}
                                            render={({ field }) => (
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={!!field.value}
                                                            onChange={e =>
                                                                field.onChange(e.target.checked)
                                                            }
                                                            color="primary"
                                                        />
                                                    }
                                                    label="Ativo"
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={3}>
                                        <Controller
                                            name="visivel"
                                            control={control}
                                            render={({ field }) => (
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={!!field.value}
                                                            onChange={e =>
                                                                field.onChange(e.target.checked)
                                                            }
                                                            color="primary"
                                                        />
                                                    }
                                                    label="Visível na lista"
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </SecaoCard>

                        {/* SEÇÃO 2: CONTATO */}
                        <SecaoCard classes={classes} titulo="Contato" icon={Contacts}>
                            <Grid container spacing={isMobile ? 2 : 3}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label="E-mail"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        type="email"
                                        {...register("email")}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Controller
                                        name="telefone"
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                value={field.value || ""}
                                                label="Telefone"
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                InputProps={{ inputComponent: MascaraTelefone }}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Controller
                                        name="numeroWhatsapp"
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                value={field.value || ""}
                                                label="WhatsApp"
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                InputProps={{ inputComponent: MascaraTelefone }}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label="Grupo WhatsApp"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        {...register("whatsappgrupo")}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label="E-mail do responsável"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        type="email"
                                        {...register("emailResponsavel")}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label="Telefone do responsável"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        {...register("telefoneResponsavel")}
                                    />
                                </Grid>
                            </Grid>
                        </SecaoCard>

                        {/* SEÇÃO 3: ENDEREÇO */}
                        <SecaoCard classes={classes} titulo="Endereço" icon={LocationOn}>
                            <Grid container spacing={isMobile ? 2 : 3}>
                                <Grid item xs={12} sm={4}>
                                    <Controller
                                        name="cep"
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                value={field.value || ""}
                                                label="CEP"
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                onBlur={e => {
                                                    field.onBlur()
                                                    buscarCep(e.target.value)
                                                }}
                                                InputProps={{ inputComponent: MascaraCEP }}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={8}>
                                    <TextField
                                        label="Endereço"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        required
                                        error={!!errors.endereco}
                                        helperText={errors.endereco?.message}
                                        {...register("endereco", {
                                            required: "Endereço é obrigatório",
                                        })}
                                    />
                                </Grid>
                                <Grid item xs={6} sm={3}>
                                    <TextField
                                        label="Número"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        required
                                        error={!!errors.numero}
                                        helperText={errors.numero?.message}
                                        {...register("numero", {
                                            required: "Número é obrigatório",
                                        })}
                                    />
                                </Grid>
                                <Grid item xs={6} sm={4}>
                                    <TextField
                                        label="Bairro"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        {...register("bairro")}
                                    />
                                </Grid>
                                <Grid item xs={8} sm={3}>
                                    <Controller
                                        name="idCidade"
                                        control={control}
                                        render={({ field }) => {
                                            const valorAtual = field.value
                                                ? {
                                                      id: field.value,
                                                      nome: watch("nomeCidade") || "",
                                                      uf: watch("ufCidade") || "",
                                                      nomeCompleto: `${watch("nomeCidade") || ""}${
                                                          watch("ufCidade")
                                                              ? " - " + watch("ufCidade")
                                                              : ""
                                                      }`,
                                                  }
                                                : null
                                            const opcoesComAtual =
                                                valorAtual &&
                                                !opcoesCidades.some(o => o.id === valorAtual.id)
                                                    ? [valorAtual, ...opcoesCidades]
                                                    : opcoesCidades
                                            return (
                                                <Autocomplete
                                                    options={opcoesComAtual}
                                                    getOptionLabel={c =>
                                                        c?.nomeCompleto ||
                                                        (c?.nome
                                                            ? `${c.nome}${c.uf ? " - " + c.uf : ""}`
                                                            : "")
                                                    }
                                                    getOptionSelected={(opt, val) =>
                                                        opt.id === val.id
                                                    }
                                                    value={valorAtual}
                                                    loading={loadingCidades}
                                                    onChange={(_, c) => {
                                                        field.onChange(c?.id ?? null)
                                                        setValue("nomeCidade", c?.nome || "", {
                                                            shouldDirty: true,
                                                        })
                                                        setValue("ufCidade", c?.uf || "", {
                                                            shouldDirty: true,
                                                        })
                                                    }}
                                                    onInputChange={(_, val, reason) => {
                                                        if (reason === "input") setInputCidade(val)
                                                    }}
                                                    renderInput={params => (
                                                        <TextField
                                                            {...params}
                                                            label="Cidade"
                                                            variant="outlined"
                                                            size="small"
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                endAdornment: (
                                                                    <>
                                                                        {loadingCidades ? (
                                                                            <CircularProgress
                                                                                size={16}
                                                                            />
                                                                        ) : null}
                                                                        {
                                                                            params.InputProps
                                                                                .endAdornment
                                                                        }
                                                                    </>
                                                                ),
                                                            }}
                                                        />
                                                    )}
                                                />
                                            )
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={4} sm={2}>
                                    <Controller
                                        name="ufCidade"
                                        control={control}
                                        render={({ field }) => (
                                            <Autocomplete
                                                options={UFS_BRASIL}
                                                getOptionLabel={uf => uf || ""}
                                                value={field.value || null}
                                                onChange={(_, uf) => {
                                                    field.onChange(uf || "")
                                                    const cidadeUfAtual = watch("ufCidade")
                                                    if (uf && uf !== cidadeUfAtual) {
                                                        setValue("idCidade", null, {
                                                            shouldDirty: true,
                                                        })
                                                        setValue("nomeCidade", "", {
                                                            shouldDirty: true,
                                                        })
                                                    }
                                                }}
                                                renderInput={params => (
                                                    <TextField
                                                        {...params}
                                                        label="UF"
                                                        variant="outlined"
                                                        size="small"
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={6} sm={6}>
                                    <TextField
                                        label="Latitude"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        {...register("latitude")}
                                        helperText={
                                            geocodificando
                                                ? "Buscando coordenadas..."
                                                : "Preenchido automaticamente a partir do endereço"
                                        }
                                    />
                                </Grid>
                                <Grid item xs={6} sm={6}>
                                    <TextField
                                        label="Longitude"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        {...register("longitude")}
                                        helperText={
                                            geocodificando
                                                ? "Buscando coordenadas..."
                                                : "Preenchido automaticamente a partir do endereço"
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </SecaoCard>

                        {/* SEÇÃO 4: VISUAL E LINKS */}
                        <SecaoCard classes={classes} titulo="Visual e Links" icon={Image}>
                            <Grid container spacing={isMobile ? 2 : 3}>
                                {representante && (
                                    <Grid item xs={12} sm={4} md={3}>
                                        <Box
                                            display="flex"
                                            flexDirection="column"
                                            alignItems="center"
                                            style={{ gap: 8 }}
                                        >
                                            <Typography variant="caption" color="textSecondary">
                                                Logo Representante
                                            </Typography>
                                            <div className={classes.logoBox}>
                                                {urlLogoRepresentante ? (
                                                    <img
                                                        src={urlLogoRepresentante}
                                                        alt="Logo representante"
                                                        className={classes.logoImg}
                                                    />
                                                ) : (
                                                    <Typography
                                                        variant="caption"
                                                        color="textSecondary"
                                                    >
                                                        Sem logo
                                                    </Typography>
                                                )}
                                            </div>
                                            <input
                                                ref={inputLogoRepRef}
                                                type="file"
                                                accept={MIME_LOGO_ACEITOS.join(",")}
                                                className={classes.inputFile}
                                                onChange={e =>
                                                    handleUploadLogo(
                                                        e.target.files?.[0],
                                                        "logo_representante"
                                                    )
                                                }
                                            />
                                            <Button
                                                startIcon={<CloudUpload />}
                                                className={classes.uploadButton}
                                                onClick={() => inputLogoRepRef.current?.click()}
                                            >
                                                Enviar Logo
                                            </Button>
                                        </Box>
                                    </Grid>
                                )}
                                <Grid
                                    container
                                    item
                                    xs={12}
                                    sm={representante ? 8 : 12}
                                    md={representante ? 9 : 12}
                                    spacing={2}
                                >
                                    <Grid item xs={12}>
                                        <TextField
                                            label="Site Institucional"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            {...register("urlSite")}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            label="URL do Facebook"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            {...register("urlFacebook")}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            label="URL do Instagram"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            {...register("urlInstagram")}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </SecaoCard>

                        {/* SEÇÃO 5: MARKETING / TRACKING */}
                        <SecaoCard
                            classes={classes}
                            titulo="Marketing / Tracking"
                            icon={TrendingUp}
                        >
                            <Grid container spacing={isMobile ? 2 : 3}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label="Tag Manager (GTM)"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        {...register("tagManager")}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label="Pixel (Meta)"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        {...register("pixel")}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label="Token API Conversão Meta"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        multiline
                                        minRows={2}
                                        {...register("apiconversao")}
                                    />
                                </Grid>
                            </Grid>
                        </SecaoCard>

                        {/* SEÇÃO 6: NEGÓCIO — apenas CLIENTEFIEL */}
                        {ehClienteFiel && (
                            <SecaoCard
                                classes={classes}
                                titulo="Negócio"
                                sufixo="(apenas CLIENTEFIEL)"
                                icon={BusinessCenter}
                            >
                                <Grid container spacing={isMobile ? 2 : 3}>
                                    <Grid item xs={12} sm={6}>
                                        <Controller
                                            name="planoAssinatura"
                                            control={control}
                                            render={({ field }) => (
                                                <FormControl
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                >
                                                    <InputLabel>Plano de assinatura</InputLabel>
                                                    <Select
                                                        {...field}
                                                        value={field.value || ""}
                                                        label="Plano de assinatura"
                                                    >
                                                        <MenuItem value="">
                                                            <em>Nenhum</em>
                                                        </MenuItem>
                                                        {PLANOS.map(p => (
                                                            <MenuItem key={p.value} value={p.value}>
                                                                {p.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Controller
                                            name="modoIzza"
                                            control={control}
                                            render={({ field }) => (
                                                <FormControl
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                >
                                                    <InputLabel>Modo Izza</InputLabel>
                                                    <Select
                                                        {...field}
                                                        value={
                                                            field.value === null ||
                                                            field.value === undefined ||
                                                            field.value === ""
                                                                ? 0
                                                                : Number(field.value)
                                                        }
                                                        onChange={e =>
                                                            field.onChange(Number(e.target.value))
                                                        }
                                                        label="Modo Izza"
                                                    >
                                                        {MODOS_IZZA.map(m => (
                                                            <MenuItem key={m.value} value={m.value}>
                                                                {m.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            )}
                                        />
                                    </Grid>
                                    {[
                                        ["permiteDesconto", "Permite desconto"],
                                        ["permiteRegistros", "Permite registros"],
                                        ["unificarCartelas", "Unificar cartelas"],
                                        ["delivery", "Possui delivery"],
                                        ["enviarWhatsappFilial", "Enviar WhatsApp p/ filiais"],
                                    ].map(([nome, label]) => (
                                        <Grid key={nome} item xs={12} sm={6} md={4}>
                                            <Controller
                                                name={nome}
                                                control={control}
                                                render={({ field }) => (
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                checked={!!field.value}
                                                                onChange={e =>
                                                                    field.onChange(e.target.checked)
                                                                }
                                                            />
                                                        }
                                                        label={label}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </SecaoCard>
                        )}

                        {/* SEÇÃO 7: PARÂMETROS OPERACIONAIS — apenas CLIENTEFIEL */}
                        {ehClienteFiel && (
                            <SecaoCard
                                classes={classes}
                                titulo="Parâmetros Operacionais"
                                sufixo="(apenas CLIENTEFIEL)"
                                icon={Tune}
                            >
                                <Grid container spacing={isMobile ? 2 : 3}>
                                    <Grid item xs={12} sm={6}>
                                        <Controller
                                            name="bonificarIndicacaoAmigos"
                                            control={control}
                                            render={({ field }) => (
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={!!field.value}
                                                            onChange={e =>
                                                                field.onChange(e.target.checked)
                                                            }
                                                        />
                                                    }
                                                    label="Bonificar indicação de amigos"
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Controller
                                            name="bonificarPesquisaSatisfacao"
                                            control={control}
                                            render={({ field }) => (
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={!!field.value}
                                                            onChange={e =>
                                                                field.onChange(e.target.checked)
                                                            }
                                                        />
                                                    }
                                                    label="Bonificar pesquisa de satisfação"
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            label="Máx. selos impressos/dia"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            {...register("maximoRegistroSelosImpressosDiarios")}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            label="Máx. selos virtuais/dia"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            {...register("maximoRegistroSelosVirtuaisDiarios")}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            label="Senha de resgate"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type={mostrarSenhaResgate ? "text" : "password"}
                                            {...register("senhaResgate")}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            size="small"
                                                            onClick={() =>
                                                                setMostrarSenhaResgate(v => !v)
                                                            }
                                                        >
                                                            {mostrarSenhaResgate ? (
                                                                <VisibilityOff fontSize="small" />
                                                            ) : (
                                                                <Visibility fontSize="small" />
                                                            )}
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </SecaoCard>
                        )}

                        {/* SEÇÃO 8: REDE — apenas CLIENTEFIEL */}
                        {ehClienteFiel && (
                            <SecaoCard
                                classes={classes}
                                titulo="Rede"
                                sufixo="(apenas CLIENTEFIEL)"
                                icon={AccountTree}
                            >
                                <Grid container spacing={isMobile ? 2 : 3}>
                                    <Grid item xs={12} sm={8}>
                                        <Controller
                                            name="idRede"
                                            control={control}
                                            render={({ field }) => {
                                                const valorAtual = field.value
                                                    ? {
                                                          id: field.value,
                                                          nome: watch("nomeRede") || "",
                                                          codigo: "",
                                                          nomeRede: "",
                                                      }
                                                    : null
                                                const opcoesComAtual =
                                                    valorAtual &&
                                                    !opcoesRede.some(o => o.id === valorAtual.id)
                                                        ? [valorAtual, ...opcoesRede]
                                                        : opcoesRede
                                                return (
                                                    <Autocomplete
                                                        options={opcoesComAtual}
                                                        getOptionLabel={est =>
                                                            est?.nome
                                                                ? `${est.nome}${
                                                                      est.codigo
                                                                          ? ` (${est.codigo})`
                                                                          : ""
                                                                  }${
                                                                      est.id != null
                                                                          ? ` — #${est.id}`
                                                                          : ""
                                                                  }`
                                                                : ""
                                                        }
                                                        getOptionSelected={(opt, val) =>
                                                            opt.id === val.id
                                                        }
                                                        value={valorAtual}
                                                        loading={loadingRede}
                                                        filterOptions={x => x}
                                                        onChange={(_, est) => {
                                                            field.onChange(est?.id ?? null)
                                                            setValue("nomeRede", est?.nome || "", {
                                                                shouldDirty: true,
                                                            })
                                                        }}
                                                        onInputChange={(_, val, reason) => {
                                                            if (reason === "input")
                                                                setInputRede(val)
                                                        }}
                                                        renderOption={est => (
                                                            <Box
                                                                display="flex"
                                                                flexDirection="column"
                                                                style={{ width: "100%" }}
                                                            >
                                                                <Box
                                                                    display="flex"
                                                                    alignItems="center"
                                                                    style={{ gap: 8 }}
                                                                >
                                                                    {est.id != null && (
                                                                        <Chip
                                                                            size="small"
                                                                            label={est.id}
                                                                            variant="outlined"
                                                                        />
                                                                    )}
                                                                    <span>{est.nome}</span>
                                                                    {est.ativo === false && (
                                                                        <Chip
                                                                            size="small"
                                                                            label="Inativo"
                                                                            style={{
                                                                                backgroundColor:
                                                                                    "#9e9e9e",
                                                                                color: "white",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </Box>
                                                                {(est.codigo || est.nomeRede) && (
                                                                    <Typography
                                                                        variant="caption"
                                                                        color="textSecondary"
                                                                    >
                                                                        {[est.codigo, est.nomeRede]
                                                                            .filter(Boolean)
                                                                            .join(" · ")}
                                                                    </Typography>
                                                                )}
                                                            </Box>
                                                        )}
                                                        renderInput={params => (
                                                            <TextField
                                                                {...params}
                                                                label="Estabelecimento pai (rede)"
                                                                variant="outlined"
                                                                size="small"
                                                                helperText="Busque por nome para vincular esta loja a uma rede."
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    endAdornment: (
                                                                        <>
                                                                            {loadingRede ? (
                                                                                <CircularProgress
                                                                                    size={16}
                                                                                />
                                                                            ) : null}
                                                                            {
                                                                                params.InputProps
                                                                                    .endAdornment
                                                                            }
                                                                        </>
                                                                    ),
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                )
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Box display="flex" alignItems="center" height="100%">
                                            <Button
                                                size="small"
                                                onClick={() => {
                                                    setValue("idRede", null, {
                                                        shouldDirty: true,
                                                    })
                                                    setValue("nomeRede", "", {
                                                        shouldDirty: true,
                                                    })
                                                }}
                                                disabled={!watch("idRede")}
                                                className={classes.discardButton}
                                            >
                                                Desvincular rede
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </SecaoCard>
                        )}

                        {/* SEÇÃO 9: LOJAS FILIAIS — apenas CLIENTEFIEL e quando há filhas */}
                        {ehClienteFiel && (carregandoFiliais || filiais.length > 0) && (
                            <SecaoCard
                                classes={classes}
                                titulo={`Lojas Filiais${
                                    carregandoFiliais ? "" : ` (${filiais.length})`
                                }`}
                                sufixo="(apenas CLIENTEFIEL)"
                                icon={Storefront}
                            >
                                <Box width="100%">
                                    {carregandoFiliais ? (
                                        <Box display="flex" justifyContent="center" p={2}>
                                            <CircularProgress size={24} />
                                        </Box>
                                    ) : (
                                        <List dense disablePadding>
                                            {filiais.map(f => (
                                                <ListItem
                                                    key={f.id}
                                                    divider
                                                    style={{
                                                        opacity: f.ativo === false ? 0.6 : 1,
                                                    }}
                                                >
                                                    <ListItemText
                                                        primary={
                                                            <Box
                                                                display="flex"
                                                                alignItems="center"
                                                                style={{
                                                                    gap: 8,
                                                                    flexWrap: "wrap",
                                                                }}
                                                            >
                                                                {f.id != null && (
                                                                    <Chip
                                                                        size="small"
                                                                        label={f.id}
                                                                        variant="outlined"
                                                                    />
                                                                )}
                                                                <span>{f.nome}</span>
                                                                {f.ativo === false && (
                                                                    <Chip
                                                                        size="small"
                                                                        label="Inativo"
                                                                        style={{
                                                                            backgroundColor:
                                                                                "#9e9e9e",
                                                                            color: "white",
                                                                        }}
                                                                    />
                                                                )}
                                                            </Box>
                                                        }
                                                        secondary={
                                                            f.codigo ? `Código: ${f.codigo}` : null
                                                        }
                                                    />
                                                </ListItem>
                                            ))}
                                        </List>
                                    )}
                                </Box>
                            </SecaoCard>
                        )}

                        <div className={classes.sticky}>
                            <Typography variant="body2" className={classes.statusText}>
                                {isDirty ? "Alterações não salvas" : "Sem alterações"}
                            </Typography>
                            <Button
                                type="button"
                                className={classes.discardButton}
                                startIcon={<Refresh />}
                                onClick={carregar}
                                disabled={salvando || !isDirty}
                            >
                                Descartar
                            </Button>
                            <Button
                                type="submit"
                                className={classes.saveButton}
                                startIcon={<Save />}
                                disabled={salvando}
                            >
                                Salvar
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}
